import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const uploadDocumentEvents = async (params) => {
  try {
    return await axios({
      method: "post",
      url: `${config.api.base_url}documents`,
      data: params,
      headers: {
        "Content-type": "application/json;multipart/form-data; charset=UTF-8",
        Authorization: getToken(),
      },
    });
  } catch (_error) {
    return {
      success: false,
      error: "Something went wrong"
    }
  }
};

export default uploadDocumentEvents;
